// src/api/uploadVideoWithTus.ts
import * as tus from 'tus-js-client'

export interface VideoUploadProgress {
  loaded: number
  total: number
  percent: number
}

// Заливка файла напрямую в Kinescope по протоколу TUS.
// endpoint уже авторизован шагом POST /videos/ — наш Authorization тут НЕ нужен.
export async function uploadVideoWithTus(params: {
  file: File
  endpoint: string
  onProgress?: (p: VideoUploadProgress) => void
  signal?: AbortSignal
}): Promise<void> {
  const { file, endpoint, onProgress, signal } = params

  return new Promise<void>((resolve, reject) => {
    const upload = new tus.Upload(file, {
      uploadUrl: endpoint,
      chunkSize: 5 * 1024 * 1024,
      metadata: { filename: file.name, filetype: file.type },
      onError: (e) => reject(e instanceof Error ? e : new Error(String(e))),
      onProgress: (loaded, total) => {
        if (onProgress) {
          onProgress({ loaded, total, percent: total > 0 ? (loaded / total) * 100 : 0 })
        }
      },
      onSuccess: () => resolve(),
    })

    if (signal) {
      signal.addEventListener('abort', () => {
        upload.abort()
        reject(new DOMException('Upload aborted', 'AbortError'))
      })
    }

    upload.start()
  })
}
